import { Head, router } from "@inertiajs/react"
import { Button } from "@/components/ui/button"
import { Separator } from "@/components/ui/separator"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import { PageHeader } from "@/components/layouts/PageHeader"
import { SourceForm } from "@/components/sources/SourceForm"
import { Trash2 } from "lucide-react"
import { useState } from "react"
import type { Source } from "@/types"

interface SourceEditProps {
  source: Source
  source_types: string[]
  categories: string[]
}

export default function Edit({ source, source_types, categories }: SourceEditProps) {
  const [deleteOpen, setDeleteOpen] = useState(false)

  function handleDelete() {
    router.delete(`/admin/sources/${source.id}`)
  }

  return (
    <>
      <Head title={`Edit ${source.name}`} />
      <div className="space-y-6">
        <PageHeader title="Edit Source" description={source.name} />

        <SourceForm
          source={source}
          sourceTypes={source_types}
          categories={categories}
          isEditing
        />

        <Separator />

        <div>
          <Dialog open={deleteOpen} onOpenChange={setDeleteOpen}>
            <DialogTrigger asChild>
              <Button variant="destructive">
                <Trash2 className="size-4" />
                Delete Source
              </Button>
            </DialogTrigger>
            <DialogContent>
              <DialogHeader>
                <DialogTitle>Delete Source</DialogTitle>
                <DialogDescription>
                  Are you sure you want to delete "{source.name}"? This will also delete all
                  associated captures. This action cannot be undone.
                </DialogDescription>
              </DialogHeader>
              <DialogFooter>
                <Button variant="outline" onClick={() => setDeleteOpen(false)}>
                  Cancel
                </Button>
                <Button variant="destructive" onClick={handleDelete}>
                  Delete
                </Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>
        </div>
      </div>
    </>
  )
}
